import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssetCategory } from 'src/app/models/asset-category';
import { Form } from 'src/app/util/entity-form.service';
import { OrganizationFormService } from '../../organization-form.service';
import { HomesickCategoryFormComponent } from '../homesick-category-form/homesick-category-form.component';

export interface HomesickCategory {
  id: string;
  name: string;
  length: number;
}

export interface HomesickCategoryFormGroup extends Form<any> {
  id: FormControl<string>;
  name: FormControl<string>;
  length: FormControl<number>;
}

@Component({
  selector: 'app-homesick-categories',
  templateUrl: './homesick-categories.component.html',
  styleUrls: ['./homesick-categories.component.scss'],
})
export class HomesickCategoriesComponent implements OnInit {
  availableCategories$: Observable<AssetCategory[]>;
  homesickCategoryForm: FormArray<FormGroup<HomesickCategoryFormGroup>>;

  // The currently selected categories and all categories
  orgCategories$ = this.organizationFormService.orgCategories$;
  categories$: Observable<AssetCategory[]> =
    this.organizationFormService.additionalFormData$.pipe(
      map(({ categories }) => categories)
    );

  constructor(
    private organizationFormService: OrganizationFormService,
    private dialog: MatDialog,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    // Gets form control to add/remove new categories
    this.homesickCategoryForm =
      this.organizationFormService.form.controls.homesick_categories;
    // Get the list of categories that don't have custom homesick days
    this.availableCategories$ = combineLatest([
      this.categories$,
      this.orgCategories$,
    ]).pipe(
      map(([categories, orgCategories]) =>
        categories.filter(
          (category) =>
            orgCategories.findIndex(
              (orgCategory) => orgCategory.id === category.id
            ) === -1
        )
      )
    );
  }

  addCategory() {
    // Open dialog to select a new category, passing in available categories and default days
    this.dialog
      .open(HomesickCategoryFormComponent, {
        data: {
          defaultHomesickDays:
            this.organizationFormService.form.get('default_homesick_days')
              .value || 14,
          categories$: this.availableCategories$,
        },
      })
      .afterClosed()
      // Add the new category to form array
      .subscribe((newCategory: HomesickCategory) => {
        if (newCategory) {
          this.homesickCategoryForm.push(this.fb.group(newCategory));
        }
      });
  }

  // Removes the category from the form array
  removeCategory(index: number) {
    this.homesickCategoryForm.removeAt(index);
  }
}
